// extracted by mini-css-extract-plugin
module.exports = {"tab":"b1ddd01198--tab--w0wAJ","active":"b1ddd01198--active--mwGtJ","focus-visible":"b1ddd01198--focus-visible--MXtrR","text":"b1ddd01198--text--oMJVB"};